import {ListConfigNamedColumn} from '@src/@types/components/List';
import ListColumn from './ListColumn';
import {IListConfigSummaryColumn} from '@src/@interfaces/components/List/IListConfigSummaryColumn';
import {IEmptyModel} from '@src/@interfaces/IEmptyModel';

export default class SummaryColumn<
        Model extends IEmptyModel = IEmptyModel
> extends ListColumn<ListConfigNamedColumn<IListConfigSummaryColumn>, Model> {
}
